enum ErrorMesages {
  'ERROR__TITLE_MESSAGE' = 'Enter a note title',
  'ERROR__DESCRIPTION_MESSAGE' = 'Enter a note text',
}

export default ErrorMesages;
